export default __webpack_public_path__ + "static/media/workshop.3b9333c6.jpg";